export default {
  save: 'Salvare',
  confirm: 'Confermare',
  cancel: 'Annullare',
  delete: 'Cancellare',
  complete: 'Completare',
  loadingTip: 'Caricando...',
  vanPagination: {
    prev: 'Precedente',
    next: 'Successivo',
  },
  vanPullRefresh: {
    pulling: 'Tirare per aggiornare...',
    loosing: 'Lasciare per aggiornare...',
  },
};
